import { ShieldCheck } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

/* Trusted Trader badge — earned by businesses with at least 1 supplier_bulk
   loan that fully repaid with group_score ≥ 750 AND zero overdue events. */
export default function TrustedTraderBadge({ size = "sm", label, withTooltip = true, stats }) {
    const sizes = {
        xs: { icon: 10, text: "text-[9px]", padX: "px-1.5", padY: "py-0.5" },
        sm: { icon: 11, text: "text-[10px]", padX: "px-2", padY: "py-0.5" },
        md: { icon: 14, text: "text-xs",    padX: "px-2.5", padY: "py-1" },
        lg: { icon: 18, text: "text-sm",    padX: "px-3.5", padY: "py-1.5" },
    };
    const s = sizes[size] || sizes.sm;
    const pill = (
        <span
            data-testid="trusted-trader-badge"
            className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-wider ${s.padX} ${s.padY} ${s.text} text-white shadow-sm relative overflow-hidden`}
            style={{
                background: "linear-gradient(135deg, #10B981 0%, #0EA5E9 50%, #6366F1 100%)",
            }}
        >
            <span
                className="absolute inset-0 opacity-30 pointer-events-none"
                style={{
                    background: "linear-gradient(120deg, transparent 30%, rgba(255,255,255,0.7) 50%, transparent 70%)",
                    backgroundSize: "200% 100%",
                    animation: "tt-shine 3s linear infinite",
                }}
            />
            <ShieldCheck size={s.icon} className="relative z-10" fill="currentColor" />
            <span className="relative z-10">{label || "Trusted"}</span>
            <style>{`@keyframes tt-shine { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`}</style>
        </span>
    );
    if (!withTooltip) return pill;
    return (
        <TooltipProvider>
            <Tooltip delayDuration={200}>
                <TooltipTrigger asChild>
                    <span>{pill}</span>
                </TooltipTrigger>
                <TooltipContent className="max-w-[220px]">
                    <div className="font-display font-semibold text-xs mb-1">Trusted Trader</div>
                    <div className="text-[11px] leading-relaxed text-slate-600">
                        Earned by completing bulk-credit orders with a Group Credit DNA score ≥ 750 and zero overdue payments.
                    </div>
                    {stats && (
                        <div className="mt-2 pt-2 border-t border-slate-200 text-[10px] text-slate-500 space-y-0.5">
                            <div>· {stats.qualified_orders} qualified order{stats.qualified_orders === 1 ? "" : "s"}</div>
                            <div>· Avg group score: <span className="font-bold text-slate-700">{stats.avg_group_score}</span></div>
                            <div>· Zero overdue events</div>
                        </div>
                    )}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
